import React from 'react'
import { injectIntl, defineMessages } from 'react-intl';
import { NavDropdown ,MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Link  } from 'react-router-dom'

class DownloadBookMenuItemBase extends React.Component {
  render () {
    const {formatMessage} = this.props.intl;
    const messages = defineMessages({
      download_book: {
        id: 'nav.download_book',
        description: 'Download PDF E-Book',
        defaultMessage: 'Download Book',
      },
      download_full_book: {
        id: 'nav.download_full_book',
        description: 'Download Full E-Book',
        defaultMessage: 'Full Book',
      },
      download_partial_book: {
        id: 'nav.download_partial_book',
        description: 'Download Partial E-Book',
        defaultMessage: 'Partial Book',
      },
    });

    return (
      <NavDropdown eventKey="list"
      title={ formatMessage(messages.download_book) }
      id="basic-nav-dropdown">
      <LinkContainer to="/book/full">
        <MenuItem>{ formatMessage(messages.download_full_book) }</MenuItem>
      </LinkContainer>
      <MenuItem divider />
      <LinkContainer to="/book/partial">
        <MenuItem>{ formatMessage(messages.download_partial_book) }</MenuItem>
      </LinkContainer>


      </NavDropdown>
    )
  }
}

export const DownloadBookMenuItem = injectIntl(DownloadBookMenuItemBase);


// WEBPACK FOOTER //
// ./modules/header/components/DownloadBookMenuItem.js